<template>
	<div class="notification-bell-container">
		<v-tooltip top max-width="250px" class="custom-tooltip">
			<div slot="activator" class="notification-bell-wrapper" @click="handleClick">
				<v-icon 
					:color="iconColor" 
					:size="iconSize" 
					:style="`color: ${iconColor} !important`"
					class="notification-icon">
					{{ icon }}
				</v-icon>
				<div v-if="count >= 0" class="notification-badge" :class="badgeColorClass">
					{{ displayCount }}
				</div>
			</div>
			<span>{{ tooltipText }}</span>
		</v-tooltip>
	</div>
</template>

<script>
export default {
	name: 'p-notification-bell',
	props: {
		// Icono a mostrar (por defecto campana)
		icon: {
			type: String,
			default: 'notifications',
		},
		// Color del icono
		iconColor: {
			type: String,
			default: 'grey',
		},
		// Tamaño del icono
		iconSize: {
			type: [String, Number],
			default: 24,
		},
		// Número a mostrar en el badge
		count: {
			type: Number,
			default: 0,
		},
		// Texto del tooltip
		tooltipText: {
			type: String,
			required: true,
		},
		// Color del badge (success, warning, error, info)
		badgeColor: {
			type: String,
			default: 'warning',
			validator: value => ['success', 'warning', 'error', 'info', 'primary'].includes(value),
		},
		// Máximo número a mostrar antes de usar "+"
		maxCount: {
			type: Number,
			default: 99,
		},
	},
	computed: {
		displayCount() {
			return this.count > this.maxCount ? `${this.maxCount}+` : this.count;
		},
		badgeColorClass() {
			return `badge-${this.badgeColor}`;
		},
	},

	methods: {
		handleClick() {
			this.$emit('click');
		},
	},
};
</script>

<style lang="scss" scoped>
.notification-bell-container {
	display: inline-block;
	position: relative;
}

.notification-bell-wrapper {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		.notification-icon {
			transform: scale(1.1);
		}
	}
}

.notification-icon {
	transition: transform 0.2s ease;
	
	// Forzar el color del icono
	&.v-icon {
		color: inherit !important;
	}
}

.notification-badge {
	position: absolute;
	top: -8px;
	right: -8px;
	min-width: 18px;
	height: 18px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	font-weight: bold;
	color: white;
	padding: 0 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

	// Colores del badge
	&.badge-success {
		background-color: #4caf50;
	}

	&.badge-warning {
		background-color: #ff9800;
	}

	&.badge-error {
		background-color: #f44336;
	}

	&.badge-info {
		background-color: #2196f3;
	}

	&.badge-primary {
		background-color: #1976d2;
	}
}

// Estilos para el tooltip personalizado
.custom-tooltip .v-tooltip__content {
	white-space: nowrap !important;
	overflow: hidden !important;
	text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-notification-bell.vue